import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../components/user/BCPAuthProvider";
import { useParams } from "react-router-dom";
import {
  Avatar,
  Box,
  Container,
  Grid,
  IconButton,
  Link,
  Typography,
  useTheme
} from "@mui/material";
import ListResponsive from "../../components/other/ListResponsive";
import {
  findGetParameter,
  getData
} from "../../components/utilities/UtilityFunctions";

import ModalLoadingFull from "../../components/modals/ModalLoadingFull";
import { handlePagingAll } from "../../components/api/APIUtilities";
import { postNotification } from "../../components/utilities/Notifications";
import {
  BCPFacebook,
  BCPInstagram,
  BCPTwitterX
} from "../../components/icons/bcp/BCPIcons";
import { getEnvironmentVariable } from "../../global/environmentVariables";
import ExternalLink from "../../components/utilities/ExternalLink";

export default function TeamProfile(props) {
  const { appRoute } = props;
  let { teamId } = useParams();
  const theme = useTheme();
  const authContext = useContext(AuthContext);

  const embed = appRoute || findGetParameter("embed") === "true";
  const leagueId = findGetParameter("league");

  const [loading, setLoading] = useState(true);
  const [team, setTeam] = useState(null);
  const [league, setLeague] = useState(null);
  const [hidePlacings, setHidePlacings] = useState(false);
  const [results, setResults] = useState(null);

  useEffect(() => {
    const go = async () => {
      try {
        var apiTeam = await getData(`/teams/${teamId}`);
        setTeam(apiTeam);

        setLoading(false);

        try {
          if (apiTeam.profileFileId || apiTeam.bannerFileId) {
            if (apiTeam.profileFileId) {
              apiTeam.profileFile = await getData(
                `/files/${apiTeam.profileFileId}`,
                {
                  queryStringParameters: {}
                }
              );
            }
            if (apiTeam.bannerFileId) {
              apiTeam.bannerFile = await getData(
                `/files/${apiTeam.bannerFileId}`,
                {
                  queryStringParameters: {}
                }
              );
            }

            setTeam(apiTeam);
          }
        } catch (err) {}

        try {
          var queryStringParameters = {
            limit: 100,
            teamId: teamId,
            "expand[]": ["event", "user", "army"]
          };
          if (leagueId) {
            queryStringParameters.leagueId = leagueId;

            var apiLeague = await getData(`/leagues/${leagueId}`, {
              queryStringParameters: {
                "expand[]": ["gameSystem", "gameStore", "gameStoreUser"]
              }
            });

            try {
              if (!apiTeam.bannerFile) {
                if (apiLeague.photoFileId) {
                  apiTeam.bannerFile = await getData(
                    `/files/${apiLeague.photoFileId}`,
                    {
                      queryStringParameters: {}
                    }
                  );
                  setTeam(apiTeam);
                }
              }
            } catch (err) {}

            if (
              apiLeague?.hidePlacings &&
              authContext?.authState?.identity?.isAdmin !== true &&
              !authContext?.authState?.identity?.adminGameSystems?.includes(
                apiLeague?.gameSystemId
              )
            ) {
              if (
                !apiLeague.gameStoreUser?.active ||
                (!apiLeague.gameStoreUser?.owner &&
                  !apiLeague.gameStoreUser?.permissions?.createLeagues)
              ) {
                let error = new Error(
                  "The Circuit owner currently has Rankings hidden."
                );
                error.name = "HidePlacings Error";
                throw error;
              }
            }

            setLeague(apiLeague);
          }
          var apiResults = await handlePagingAll(
            `/eventplacings`,
            queryStringParameters
          );

          apiResults.sort((a, b) => {
            if (apiLeague?.defaultPlacingType !== "ELO Points") {
              if (a.points !== b.points) {
                if (a.points || b.points) {
                  if (!a.points) return 1;
                  if (!b.points) return -1;
                  if (a.points !== b.points) return b.points - a.points;
                }
              }
            }

            if (a.placing || b.placing) {
              if (!a.placing) return 1;
              if (!b.placing) return -1;
              return a.placing - b.placing;
            }

            return 0;
          });

          var scoreDict = {};
          var scores = 0;
          // Top ten scores and each player can only contribute 3 scores
          apiResults.forEach((result) => {
            if (scores === 10) {
              return;
            }
            if (result.user) {
              if (!scoreDict[result.user.id]) {
                scoreDict[result.user.id] = 0;
              }
              scoreDict[result.user.id]++;
              if (scoreDict[result.user.id] <= 3) {
                scores++;
                result.bold = true;
              }
            }
          });

          setResults(apiResults);
        } catch (err) {
          if (err.name === "HidePlacings Error") {
            postNotification("warning", err.message);
            setHidePlacings(true);
            setResults([]);
          } else {
            postNotification("error", err);
          }
        }
      } catch (err) {
        postNotification("error", err);
        window.location.assign("/");
      }
    };

    go();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      {loading && <ModalLoadingFull />}
      {!loading && team && (
        <Box sx={{ width: "100%" }}>
          <Container sx={{ pt: 2, pb: 2 }} maxWidth="lg">
            <Grid container sx={{ gap: 2 }}>
              <Grid
                item
                xs={12}
                sx={{
                  borderRadius: 1,
                  background: `url(${
                    team?.bannerFile?.url ||
                    `${getEnvironmentVariable(
                      "SYSTEM_IMAGES_CLOUDFRONT"
                    )}/images/RankingsImage${
                      theme?.palette?.mode === "dark" ? "Dark" : ""
                    }.png`
                  })`,
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  height: ["250px", "350px"]
                }}
              ></Grid>
              <Grid item xs={12} sx={{ position: "relative" }}>
                <Box
                  sx={{
                    position: "absolute",
                    top: "-90px",
                    left: "50%",
                    transform: "translate(-50%, 0%)"
                  }}
                >
                  <Avatar
                    alt={`${team?.name}`}
                    src={team?.profileFile?.url}
                    sx={{
                      width: 150,
                      height: 150,
                      border: "3px solid #fff "
                    }}
                  />
                </Box>
                <Box
                  sx={{
                    position: "absolute",
                    bottom: "8px",
                    right: "8px"
                  }}
                >
                  {team.socials?.Facebook && (
                    <IconButton
                      color="primary"
                      href={`https://facebook.com/${team.socials.Facebook}`}
                      target="_blank"
                    >
                      <BCPFacebook />
                    </IconButton>
                  )}
                  {team.socials?.Twitter && (
                    <IconButton
                      color="primary"
                      href={`https://twitter.com/${team.socials.Twitter}`}
                      target="_blank"
                    >
                      <BCPTwitterX />
                    </IconButton>
                  )}
                  {team.socials?.Instagram && (
                    <IconButton
                      color="primary"
                      href={`https://instagram.com/${team.socials.Instagram}`}
                      target="_blank"
                    >
                      <BCPInstagram />
                    </IconButton>
                  )}
                </Box>
                <Box
                  sx={{
                    p: 2,
                    borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
                    borderRadius: 1,
                    boxShadow: 1,
                    backgroundColor: "background.secondary",
                    pt: "70px",
                    textAlign: "center"
                  }}
                >
                  <Typography variant="h3" gutterBottom>
                    {team.name}
                  </Typography>
                  {team.bio && team.bio !== "" && (
                    <Typography variant="body1" gutterBottom paragraph>
                      {team.bio.split("\n").map((i, key) => {
                        return <Box key={key}>{i}</Box>;
                      })}
                    </Typography>
                  )}
                </Box>
              </Grid>

              {hidePlacings ? (
                <Grid
                  item
                  xs={12}
                  sx={{
                    p: 2,
                    borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
                    borderRadius: 1,
                    boxShadow: 1,
                    backgroundColor: "background.secondary",
                    textAlign: "center"
                  }}
                >
                  <Typography variant="h4" gutterBottom>
                    The Circuit owner currently has Rankings hidden
                  </Typography>
                </Grid>
              ) : (
                <Grid
                  item
                  xs={12}
                  sx={{
                    p: 2,
                    borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
                    borderRadius: 1,
                    boxShadow: 1,
                    backgroundColor: "background.secondary"
                  }}
                >
                  <ListResponsive
                    originalList={results}
                    doSearch={true}
                    searchProps={{
                      label: "Search Results",
                      performSearch: (originalList, searchText) => {
                        if (!searchText || searchText === "") {
                          return originalList;
                        } else {
                          var filteredList = originalList.filter(function (el) {
                            if (
                              el?.event?.name
                                ?.toLowerCase()
                                .includes(searchText)
                            )
                              return true;
                            if (
                              el?.faction?.name
                                ?.toLowerCase()
                                .includes(searchText)
                            )
                              return true;
                            if (
                              el?.user?.firstName
                                ?.toLowerCase()
                                .includes(searchText)
                            )
                              return true;
                            if (
                              el?.user?.lastName
                                ?.toLowerCase()
                                .includes(searchText)
                            )
                              return true;
                            return false;
                          });
                          return filteredList;
                        }
                      }
                    }}
                    rowProps={{
                      headings: (
                        <Grid
                          item
                          xs={12}
                          sx={{
                            p: 1,
                            borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
                            borderRadius: "4px 4px 0 0",
                            backgroundColor: "table.headerBackground",
                            color: "table.headerColor"
                          }}
                        >
                          <ListRow heading league={league} />
                        </Grid>
                      ),
                      mapFunction: (row, index) => (
                        <Grid
                          item
                          xs={12}
                          key={index}
                          sx={{
                            p: 1,
                            borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
                            fontWeight: row.bold ? "550" : null
                          }}
                        >
                          <ListRow
                            row={row}
                            index={index}
                            leagueId={leagueId}
                            league={league}
                            embed={embed}
                          />
                        </Grid>
                      )
                    }}
                  />
                </Grid>
              )}
            </Grid>
          </Container>
        </Box>
      )}
    </>
  );
}

const ListRow = ({ heading, row, leagueId, embed, league }) => {
  return (
    <Grid container spacing={1}>
      {!league?.clubLeague ? (
        <Grid item xs>
          <Typography sx={{ fontWeight: "inherit" }}>
            {heading ? (
              "Player"
            ) : (
              <ExternalLink
                href={`/user/${row.user?.id}?embed=${embed ? "true" : "false"}${
                  leagueId ? `&league=${leagueId}` : ""
                }`}
                target="_blank"
                underline="none"
              >
                {`${row.user?.firstName ? row.user?.firstName : ""} ${
                  row.user?.lastName ? row.user?.lastName : ""
                }`.trim()}
              </ExternalLink>
            )}
          </Typography>

          {!heading && Boolean(row.faction || row.team) && (
            <Typography
              variant="caption"
              sx={{ display: ["inherit", "inherit", "none"] }}
            >
              <Link
                href={`/truncated/event/${row.event?.id}?embed=${
                  embed ? "true" : "false"
                }${leagueId ? `&league=${leagueId}` : ""}`}
                underline="none"
              >
                {row.event?.name}
              </Link>
              {Boolean(row.faction?.id) && " - "}
              {row.faction?.id && (
                <>
                  {getEnvironmentVariable("HIDE_RANKINGS") ? (
                    row.faction?.name
                  ) : (
                    <Link
                      href={`/rankings/players?embed=${
                        embed ? "true" : "false"
                      }&army=${row.faction?.id}${
                        leagueId ? `&league=${leagueId}` : ""
                      }`}
                      underline="none"
                    >
                      {row.faction?.name}
                    </Link>
                  )}
                </>
              )}
            </Typography>
          )}
        </Grid>
      ) : null}
      <Grid
        item
        xs
        sx={
          league?.clubLeague
            ? null
            : {
                display: ["none", "none", "inherit"]
              }
        }
      >
        {heading ? (
          "Event"
        ) : (
          <Link
            href={`/truncated/event/${row.event?.id}?embed=${
              embed ? "true" : "false"
            }${leagueId ? `&league=${leagueId}` : ""}`}
            underline="none"
          >
            {row.event?.name}
          </Link>
        )}
      </Grid>
      {!league?.clubLeague ? (
        <Grid item xs sx={{ display: ["none", "none", "inherit"] }}>
          {heading
            ? league?.gameSystem?.factionLabel || "Faction"
            : row.faction && (
                <>
                  {getEnvironmentVariable("HIDE_RANKINGS") ? (
                    row.faction?.name
                  ) : (
                    <Link
                      href={`/rankings/players?embed=${
                        embed ? "true" : "false"
                      }&army=${row.faction?.id}${
                        leagueId ? `&league=${leagueId}` : ""
                      }`}
                      underline="none"
                    >
                      {row.faction?.name}
                    </Link>
                  )}
                </>
              )}
        </Grid>
      ) : null}
      <Grid
        item
        xs
        sx={{
          textAlign: "center",
          width: "100px",
          maxWidth: "100px !important"
        }}
      >
        {heading ? "Placing" : row.placing}
      </Grid>
      <Grid
        item
        xs
        sx={{
          textAlign: "right",
          width: "100px",
          maxWidth: "100px !important"
        }}
      >
        {heading ? "Points" : row.points || 0}
      </Grid>
    </Grid>
  );
};
